import { Stack } from "@fluentui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AllReports from "../components/ReportCatalog/AllReports/AllReports";
import { isReportExistsPredicate, mapReportsDataPredicate } from "../components/ReportCatalog/ReportCatalog.common";
import { CardData } from "../components/ReportCatalog/ReportCatalog.interfaces";
import { logPageView } from "../helper/AppInsightsHelper";
import { useGetReportCatalogDataQuery } from "../slices/ExploreReports.slice";

const style = {
  "--font-family": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
  margin: 10
};

export default function ReportCatalog() {
  const navigate = useNavigate();
  const [data, setData] = React.useState<CardData[]>([]);
  const { data: queryData, error, isLoading } = useGetReportCatalogDataQuery(null);

  const onCardSelected = React.useCallback((card: CardData) => {
    const reportLink = card.url;
    const reportParser = reportLink?.split("/reports")[1];
    const reportId = reportParser?.split("/")[1] || ("" as string);
    navigate(`/reportview/reportid=${reportId}`, { state: { reportName: card.title, reportLink: card.url } });
  }, []);

  const onDataLoaded = React.useCallback((d?: any[]) => {
    setData(
      (d || [])
        .map(mapReportsDataPredicate)
        .filter(isReportExistsPredicate)
        .sort((a, b) => (a.description > b.description ? -1 : a.description < b.description ? 1 : 0))
    );
  }, []);

  const onDataError = React.useCallback(() => {
    setData([]);
  }, []);

  useEffect(() => {
    if (queryData) {
      onDataLoaded(queryData);
    }
    if (error) {
      onDataError();
    }
  }, [error, onDataError, onDataLoaded, queryData]);

  useEffect(() => logPageView("Report Catalog Page", window.location.href), []);

  return (
    <div className="mainCard" style={style}>
      <div>
        <Stack>
          <AllReports cards={data} onCardSelected={onCardSelected} loading={isLoading} />
        </Stack>
      </div>
    </div>
  );
}
